"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddOnPriceCalculationInformation = getAddOnPriceCalculationInformation;
exports.getPriceLabelAndSublabel = getPriceLabelAndSublabel;
exports.sortCategories = sortCategories;
const constants_1 = require("../constants/constants");
const common_helpers_1 = require("./common-helpers");
const formatting_helpers_1 = require("./formatting-helpers");
const copy_1 = __importDefault(require("../constants/copy"));
function getAddOnPriceCalculationInformation({ priceByDay, priceByGuest, quantity, }) {
    const isPricePerDayAndGuest = priceByDay === constants_1.PER_DAY && priceByGuest === constants_1.PER_GUEST;
    const isPricePerDay = priceByDay === constants_1.PER_DAY && priceByGuest === constants_1.SET_GUEST;
    const isPricePerGuest = priceByDay === constants_1.SET_DAY && priceByGuest === constants_1.PER_GUEST;
    if (isPricePerDayAndGuest && quantity > 1) {
        return copy_1.default.PER_GUEST_PER_DAY_INFO;
    }
    if (isPricePerDay && quantity > 1) {
        return copy_1.default.PER_DAY_INFO;
    }
    if (isPricePerGuest && quantity > 1) {
        return copy_1.default.PER_GUEST_INFO;
    }
    return "";
}
function getPriceLabelAndSublabel(addOn) {
    const priceInformation = getPriceInformation(addOn);
    const priceLabel = getPriceLabel({
        dueBeforeTrip: priceInformation.dueBeforeTrip,
        isDeposit: !!priceInformation.dueAfterTrip,
        addOn,
    });
    const priceSublabel = getPriceSublabel(priceInformation.total, priceInformation.dueAfterTrip);
    return { priceLabel, priceSublabel };
}
// Sorts so that "other" is always last.
function sortCategories(categories) {
    return categories.sort((category) => category === constants_1.ADD_ON_CATEGORIES.OTHER ? 1 : -1);
}
function getPriceLabel({ dueBeforeTrip, isDeposit, addOn, }) {
    const formattedPrice = (0, formatting_helpers_1.formatPrice)(dueBeforeTrip);
    const priceLabelTexts = [
        formattedPrice,
        getDepositLabel(isDeposit),
        getPriceUnit(addOn),
    ];
    return priceLabelTexts.filter(Boolean).join(" ");
}
function getPriceSublabel(total, dueAfterTrip) {
    if (!dueAfterTrip)
        return null;
    const formattedTotal = (0, formatting_helpers_1.formatPrice)(total);
    const formattedDueAfterTrip = (0, formatting_helpers_1.formatPrice)(dueAfterTrip);
    return `${formattedTotal} ${copy_1.default.TOTAL} ${formattedDueAfterTrip} ${copy_1.default.DUE_AFTER_TRIP}`;
}
function getDepositLabel(isDeposit) {
    return isDeposit ? copy_1.default.DEPOSIT : null;
}
function getPriceInformation(addOn) {
    // use isNil since 0 is a valid value for deposit_amount
    if (!(0, common_helpers_1.isNil)(addOn.deposit_amount)) {
        return {
            total: addOn.unit_price,
            dueAfterTrip: addOn.unit_price - addOn.deposit_amount,
            dueBeforeTrip: addOn.deposit_amount,
        };
    }
    // use isNil since 0 is a valid value for deposit_percentage
    if (!(0, common_helpers_1.isNil)(addOn.deposit_percentage)) {
        const percentageFraction = addOn.deposit_percentage / 100;
        return {
            total: addOn.unit_price,
            dueAfterTrip: addOn.unit_price * (1 - percentageFraction),
            dueBeforeTrip: addOn.unit_price * percentageFraction,
        };
    }
    return {
        total: addOn.unit_price,
        dueAfterTrip: 0,
        dueBeforeTrip: addOn.unit_price,
    };
}
function getPriceUnit(entity) {
    const isPerGuest = isPricingPerGuest(entity);
    const isPerDay = isPricingPerDay(entity);
    const dayUnit = isPerDay ? `/ ${copy_1.default.DAY}` : "";
    const guestUnit = isPerGuest ? `/ ${copy_1.default.GUEST}` : "";
    if (dayUnit && guestUnit)
        return `${dayUnit} ${guestUnit}`;
    if (!dayUnit && !guestUnit)
        return "";
    return dayUnit || guestUnit;
}
function isPricingPerDay(entity) {
    return entity.price_by_day === constants_1.PER_DAY;
}
function isPricingPerGuest(entity) {
    return entity.price_by_guest === constants_1.PER_GUEST;
}
